
<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
import draggable from 'vuedraggable'

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}

export default {
  mixins: [navigation],
  name: "app",
  components:{draggable},
  deactivated() {
    this.time = 75;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.time > 0 && !this.sent) {
          this.time--;
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage(this.next);
          }
        }
      }, 1000);
    }
  },
  data() {
    return {
      last: "P_49",
      next: "P_51",
      topic:
        "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      dialog: false,
      resultado: 0,
      response: "none",
      sent: false,
      show: false,
      correcta: false,
      completo: "none",
      time: 120,
      timer: null,
      interaction: {
        id: "TCC.p5",
        questionText: "Completa la frase",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      },
      reactivos: [
        {
          pregunta: "Una opción para pagar un viaje es un ",
          correctas: ["CRÉDITO NÓMINA"],
          respuesta: [],
          respuestaUnica: "",
          resultado: 0
        },
        {
          pregunta: " donde mi sueldo es garantía del pago. Otra manera de pagarlo es con ",
          correctas: ["TARJETA DE CRÉDITO"],
          respuesta: [],
          respuestaUnica: "",
          resultado: 0
        },
        {
          pregunta: ", ya que el proceso puede ser más simple o con ",
          correctas: ["CRÉDITO AL CONSUMO"],
          respuesta: [],
          respuestaUnica: "",
          resultado: 0
        }
      ],
      opciones: [
        "CRÉDITO HIPOTECARIO",
        "CRÉDITO NÓMINA",
        "CRÉDITO AUTOMOTRIZ",
        "TARJETA DE CRÉDITO",
        "CRÉDITO AL CONSUMO"
      ]
    };
  },
  beforeMount: function() {
    shuffle(this.opciones);
  },
  beforeUpdate: function() {
    var opciones = this.opciones;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          opciones.push(reactivo.respuesta.shift());
        } else {
          opciones.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correctas.includes(reactivo.respuesta[0])) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
    }
  },
  beforeMount: function() {
    shuffle(this.opciones);
  },
  beforeUpdate: function() {
    var opciones = this.opciones;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          opciones.push(reactivo.respuesta.shift());
        } else {
          opciones.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  computed: {
    completed() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "") {
          complete = false;
        }
      });
      return complete;
    },
    responseIsNone() {
      return {
        "btn-primary": this.response != "none",
        "btn-secondary": this.response == "none"
      };
    },
    created() {
      console.log("GLOBAL SERVICE: created");
      let service = this.$dragula.$service;
      service.options("second", {});
      console.log("GLOBAL SERVICE: ready");
    }
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row wrap justify-center)
        v-flex(sm6, md6, lg9, xl7, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat).centerCard
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 5 DE 5
            img.pt-3(style="width:61px; heigth:67px;", src="@/assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.mx-2.px-0
              | Completa la siguiente oración con las palabras correspondientes.
            
            v-layout(row, flex, align-center, align-content-center)
              v-flex.px-1(xs6, text-xs-center, align-content-center)
                v-card.py-0(flat, color='grey lighten-4 ', v-for='(reactivo, index) in reactivos ', :key='index ')
                  v-layout.my-2.text-xs-right(flat)
                    v-flex.py-2.my-0(xs11)
                      .blockquote.pregunta.text-xs-left(:class="{'caption': $vuetify.breakpoint.xs}")
                        | {{reactivo.pregunta}}
                    v-flex.py-3.mr-4.ml-0(xs1, text-xs-start)
                      v-icon(size='15px', v-if='sent && (reactivos[index].resultado==0) ', color='red ') fas fa-times
                      v-icon(size='15px', v-if='sent && (reactivos[index].resultado==1) ', color='green ') fas fa-check
              v-flex.px-1(xs3, text-xs-center)
                v-card.py-1(flat, v-for='(reactivo, index) in reactivos ', :key='index ')
                    draggable.selectorBox(v-model="reactivos[index].respuesta", group="people", tag='div')
                      .reactivo.text-center.text-uppercase.pt-3(v-for='reactivo in reactivos[index].respuesta ', :key='index ')
                        p(:class="{'caption': $vuetify.breakpoint.xs}") {{reactivo}}

              v-flex.px-1(xs3, text-xs-center)
                draggable(v-model="opciones", group="people")
                  v-card.py-1(flat, style='cursor: pointer;', v-for='respuesta in opciones ', :key='respuesta ')
                    .selectorBox
                      .reactivo.text-center.text-uppercase.pt-3(:class="{'caption': $vuetify.breakpoint.xs}") 
                        | {{respuesta}}

          v-layout(row, justify-center)
            v-flex
              div(v-if='!sent')
                v-btn.btn(color='secondary ', :disabled='opciones.length!=2', @click='sendResult() ')
                  | Enviar
              div(v-if='sent')
                v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                  | Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (resultado==1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien contestado! 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  b Conforme a tus respuestas, el texto correcto se lee así:
                                p.text-sm-left.px-5.my-0
                                  | Una opción para pagar un viaje es un crédito nómina, donde mi sueldo es garantía del pago. Otra manera de pagarlo es con tarjeta de crédito ya que el proceso puede ser más simple o con crédito al consumo. 
                          .pt-1.pr-2(v-if='sent && (resultado!=1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Tu respuesta puede mejorar! 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  b Conforme a tus respuestas, el texto correcto se lee así:
                                p.text-sm-left.px-5.my-0
                                  | Una opción para pagar un viaje es un crédito nómina, donde mi sueldo es garantía del pago. Otra manera de pagarlo es con tarjeta de crédito ya que el proceso puede ser más simple o con crédito al consumo. 
                          v-btn.btn.dialog_btn.my-4(color='accent ', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
